import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GlobalSearchService {
  private openSearchSubject = new Subject<void>();
  public openSearch$ = this.openSearchSubject.asObservable();

  openSearch(): void {
    this.openSearchSubject.next();
  }
}
